import { Col, Form, Row } from "antd";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import CleanButton from "../../../common/components/CleanButton";
import Page from "../../../common/components/Page";
import QueryDateRange from "../../../common/components/QueryDateRange";
import { QueryList } from "../../../common/constants/Helpers";
import { buildLookupRequest } from "../../../state/connect-api";
import { useQueryListMutation } from "../../../state/query-api";
import { updateQueryList } from "../../../state/queryStore";
import QueryDropdowns from "../QueryDropdowns";
import useQuery from "../TR-CR-Query/useQuery";

const AttorneyCivilQuery = () => {
  const { initialValues, handleTypeChange, type, form, allTypes, handleSubmit } = useQuery();
  const [getQueryList] = useQueryListMutation();
  const dispatch = useDispatch();

  useEffect(() => {
    const lookupRequest = buildLookupRequest("CIVILATTORNEY");
    const fetch = async () => {
      const queryList = await getQueryList(lookupRequest).unwrap();
      dispatch(updateQueryList({ queryList: queryList }));
    };

    fetch();
  }, [dispatch, getQueryList]);

  return (
    <Page>
      <Page.Title title="Attorney Civil Query" icon="columns" />
      Dates must be in the form MM/DD/YYYY (Example: 01/31/2012). If no dates are given, then today's date will be used.
      <Page.Toolbar>
        <CleanButton onClick={() => handleSubmit(QueryList.CivilAttorney, form.getFieldValue("startAttorney"), form.getFieldValue("endAttorney"))} icon="check-double">
          Submit
        </CleanButton>
      </Page.Toolbar>
      <Page.Content>
        <Form layout="vertical" form={form} initialValues={initialValues}>
          <Row gutter={[16, 16]}>
            <Col xl={10} lg={10} md={24} sm={24} xs={24}>
              <QueryDateRange form={form} />
            </Col>
            <Col xl={14} lg={14} md={24} sm={24} xs={24}>
              <QueryDropdowns.TRCRAttorneyCaseQuery type={type} handleTypeChange={handleTypeChange} allTypes={allTypes} />
            </Col>
          </Row>
        </Form>
      </Page.Content>
    </Page>
  );
};

export default AttorneyCivilQuery;
